import { render, staticRenderFns } from "./Sidebar.vue?vue&type=template&id=44759458&scoped=true&"
import script from "./Sidebar.vue?vue&type=script&lang=js&"
export * from "./Sidebar.vue?vue&type=script&lang=js&"
import style0 from "@/assets/scss/sidebar.scss?vue&type=style&index=0&id=44759458&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44759458",
  null
  
)

export default component.exports